// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-Backdrop-module--cls1--LM1I7","cls2":"Lightbox-Backdrop-module--cls2--iLJkO Lightbox-Backdrop-module--cls1--LM1I7"};